import QRCode from "react-qr-code"
import phonepe_svg from '../media/phonepe.svg'
import gpay_svg from '../media/GPay.svg'
import bhim_svg from '../media/BHIM.svg'
import paytm_svg from '../media/paytm.svg'
import logo_img from '../media/logo.svg'
import './DepositMain.css'

const NeftPage = ({ paymentImg,
    orderDetails,
    pendingConfirmation,
    redirectLinks,
    getBase64,
    fileValue,
    setFileValue,
    cancelButton,
    copyToClipboard,
    image,
    removeImg,
    togglePreview,
    errMsg
}) => {



    return <div className="content">
        {
            <div className="deposit_page neft_div">
                <div className="text-center header_tag w-100">
                    <button title="Cancel" className="back_button1 fa-solid fa-xmark" onClick={cancelButton}></button>
                    <div className="d-flex align-items-center"><img src={logo_img} height="30px" alt="" />&nbsp; <h4 className="title m-0" style={{ fontSize: "28px", fontWeight: "700" }}> P2way</h4></div>
                    {<p id="timer"><span id="countdown">00:00</span></p>}
                </div>
                <div className="qr-code-container1">
                    <h6>Please use the below Bank Details for transferring the funds.</h6>
                    <div className="w-100 mt-2">
                        {redirectLinks?.traderBankName && <p><span>Bank Name</span><span>{redirectLinks?.traderBankName ? redirectLinks?.traderBankName : "N/A"}</span></p>}
                        {redirectLinks?.traderBankAccountNumber && <p><span>Account Number</span><span>{redirectLinks?.traderBankAccountNumber ? redirectLinks?.traderBankAccountNumber : "N/A"}</span></p>}
                        {redirectLinks?.traderBankAccountHolderName && <p><span>Account Holder Name</span><span>{redirectLinks?.traderBankAccountHolderName ? redirectLinks?.traderBankAccountHolderName : "N/A"}</span></p>}
                        <p><h6>Amount</h6><h6>{redirectLinks?.transactionAmount ? redirectLinks?.transactionAmount : "0.00"} {redirectLinks?.currency ? redirectLinks?.currency : "N/A"}</h6></p>
                        <p><span>Order Id</span><span>{orderDetails?.orderId ? orderDetails?.orderId : "N/A"}<span className="ms-1" style={{ cursor: 'pointer' }} onClick={() => { copyToClipboard(orderDetails?.orderId) }}>
                            <i className="fa-regular fa-copy " style={{ fontSize: "20px" }}></i>
                        </span></span></p>
                    </div>
                </div>
                <div className="qr-code-container1 mt-2">
                    <div className="">
                        <h6>Please upload receipt after payment.</h6>
                        {/* <div className="form-group" id="UTRNumber">
                            {orderDetails.utr && orderDetails.utr !== orderDetails.orderId && <b className="text-center text-danger">UTR must match with OrderId</b> }
                            <label>Enter UTR:</label>
                            <input type="text" placeholder="UTR Number" value={orderDetails?.utr} onChange={(e) => { setOrderDetails({ ...orderDetails, utr: e.target.value }) }} id="utr" name="utr" required />
                        </div> */}
                        <h6 style={{ fontSize: "14px", fontWeight: "700" }} className="text-center ms-auto me-auto text-danger">{errMsg}</h6>
                        {!image && <div className=" d-flex justify-content-left mt-2" style={{ width: "90%" }} id="paymentProofDiv">
                            <input type="file" className="mb-4" placeholder="Upload Payment Proof" accept="image/png,image/jpg,image/jpeg" style={{ color: "#000", display: "none" }} onChange={(e) => { getBase64(e); setFileValue(e.target.value?.split("\\").pop()) }} name="paymentProof" id="paymentProof" />
                            <div id="fileName" onClick={() => document.getElementById("paymentProof").click()}>
                                <button className="green_btn">Choose File</button>
                                <span style={{ color: "#777" }}>{fileValue ? fileValue : 'Upload Payment Proof'}</span>
                            </div>
                        </div>}
                        {
                            image && <div className="img_preview text-center mt-3 ms-auto me-auto df">
                                <button title="Remove" className="remove_img fa-solid fa-xmark" onClick={removeImg}></button>
                                <div onClick={togglePreview}>Preview <i className="fa fa-eye"></i></div>
                                <img src={'data:image/png;base64,' + image} style={{ cursor: "pointer" }} height="100px" width="100px" alt="" onClick={togglePreview} />
                            </div>
                        }
                        <div className="text-center">
                            <button id="PayNow1" className="popup-button w-50 p-0 ms-auto me-auto" disabled={!(paymentImg)} onClick={() => { pendingConfirmation() }}>Confirm Payment</button>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>

}

export default NeftPage